import React from 'react';

export default function CodeOfConduct() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 id="code-of-conduct" className="text-3xl text-center font-bold text-blue-900 mb-6">Code of Conduct</h1>

        <p className="mb-4 text-gray-700">
          Million2Trillion is committed to maintaining a respectful, collaborative, and professional environment for all
          members of our platform — including traders, educators, investors, coders, influencers, and partners.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-3">1. Respect and Inclusivity</h2>
        <p className="mb-4 text-gray-700">
          Treat everyone with respect, regardless of their background, experience, beliefs, or market perspective.
          Harassment, hate speech, personal attacks, and discrimination of any kind will not be tolerated.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-3">2. Honesty and Integrity</h2>
        <p className="mb-4 text-gray-700">
          Be transparent in your actions. Do not share false signals, misrepresent performance, or impersonate
          others. All users are expected to act with integrity, especially when promoting services or offering mentorship.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-3">3. Constructive Participation</h2>
        <p className="mb-4 text-gray-700">
          Contribute positively to discussions, feedback, and learning opportunities. Share knowledge with clarity,
          collaborate with openness, and avoid spam or repetitive self-promotion.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-3">4. Protection of Intellectual Property</h2>
        <p className="mb-4 text-gray-700">
          Respect original content creators. Do not copy, repackage, or sell tools, strategies, or educational material
          without permission or credit.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-3">5. Reporting and Enforcement</h2>
        <p className="mb-4 text-gray-700">
          If you observe behavior that violates this Code, please report it through our platform’s moderation system.
          We reserve the right to warn, suspend, or ban any user found violating these guidelines.
        </p>

        <p className="mt-8 text-sm text-gray-500 italic">
          Last updated: June 2025
        </p>
      </div>
    </div>
  );
}
